import React from 'react';
import useGraphTopicSelection from 'pages/ReprSpeechGraphPage/hooks/useGraphTopicSelection';
import useModalState from 'modals/useModalState';
import { RxCross1 } from 'react-icons/rx';
import { colors } from 'resource/styling';

export default function TopicSelectionModal() {
	const { availableTopics,currentTopic,currentAxis, setCurrentTopic, setCurrentAxis, currentAxisAvailability} = useGraphTopicSelection()
	const {removeModal} = useModalState()


	return (
	
		<div className="w-full h-full flex flex-col">
			<div className="flex flex-row items-center justify-start w-full">
				<button onClick={() => removeModal('topicSelection')} type="button" className="hover:scale-125 transition">
					<RxCross1 className="h-5 w-5" />
				</button>
				<h1 className="text-2xl font-bold w-full text-start pl-2">トピックを選んでください</h1>
			</div>
			<div className="flex-1 min-h-0 flex flex-col">
				<div className="h-[50%] flex flex-wrap flex-row items-center w-full justify-start overflow-y-scroll border-4 rounded-md border-slate-400">
					{availableTopics?.availability?.map((topic) => (
						
						topic.disabled?null:<button key={topic.name} type="button" onClick={() => setCurrentTopic(topic.name)} className={`${currentTopic === topic.name ? colors.primary : colors.tertiary} m-2 p-2 rounded-md hover:scale-110 transition`}>
							{topic.jpn}
						</button>
					))
					}
				</div>
				<div className="h-[50%] flex flex-col">
					<h1 className="text-2xl font-bold w-full text-start">対立軸を選んでください</h1>
					<div className="flex flex-wrap flex-row items-center justify-start w-full overflow-y-scroll border-4 rounded-md border-slate-400">
						{currentAxisAvailability?.map((axis) => (
							axis.disabled?null:
							<button key={axis.name} type="button" onClick={() => setCurrentAxis(axis.name)} className={`${currentAxis === axis.name ? colors.primary : colors.tertiary} m-2 p-2 rounded-md hover:scale-110 transition`}>
								{axis.jpn}
							</button>
						))}
					</div>
				</div>
			</div>

			
		</div>
	);
}
		